import { Bell, HelpCircle } from "lucide-react";
import toast from "react-hot-toast";
import { useAuthStore } from "../store/useAuthStore";
import ClientSidebar from "../components/portal/ClientSidebar";
import ClientTopBar from "../components/portal/ClientTopBar";
import ClientFilesModule from "../components/client-portal/ClientFilesModule";
import ErrorBoundary from "../components/ErrorBoundary";

// Standalone Files page so the module is reachable from any client page (not
// only as a dashboard tab).
const ClientFilesPage = () => {
  const { authUser } = useAuthStore();
  return (
    <div className="min-h-screen bg-[#f8f9ff] text-on-surface flex">
      <ClientSidebar active="files" />
      <div className="flex-1 min-w-0">
        <ClientTopBar title="Files" />
        <ErrorBoundary label="the Files module">
          <ClientFilesModule />
        </ErrorBoundary>
      </div>
    </div>
  );
};

export default ClientFilesPage;
